<template>
  <div>
    <b-modal
      id="modal-agreement"
      ref="modalAgreement"
      :title="title"
      footer-class="justify-content-center"
      no-close-on-esc
      no-close-on-backdrop
      scrollable
    >
      <template v-slot:modal-header="{ close }">
        <page-headline tag="h1" :title="title" class="mb-0" />
        <slot name="right-actions" v-if="isNotice">
          <button type="button" class="close" @click="close()">
            <span aria-hidden="true">&times;</span>
          </button>
        </slot>
      </template>
      <!-- 注意事項 內容-->
      <notice-content v-if="!isNotice"></notice-content>
      <!-- 「隱私權及資訊安全政策」暨「個人資料使用說明」 內容-->
      <privacy-info-security-policy
        v-if="title == '「個人資料使用說明」暨「隱私權及資訊安全政策」'"
      ></privacy-info-security-policy>

      <b-form-group class="text-center" v-if="!isNotice">
        <b-form-checkbox v-model="agreement">我已閱讀注意事項</b-form-checkbox>
      </b-form-group>
      <template v-slot:modal-footer="{ close }" :class="'agreementBox'">
        <div class="text-center">
          <b-button
            v-if="!isNotice"
            :variant="!agreement ? 'secondary' : 'action'"
            :disabled="!agreement"
            class="mx-1"
            @click="QrgetData(getUrl)"
            >繼續</b-button
          >
          <b-button v-if="!isNotice" variant="outline-secondary" class="mx-1" @click="goHome()"
            >取消</b-button
          >
          <b-button v-if="isNotice" variant="primary" class="mx-1" @click="close()">關閉</b-button>
        </div>
        <div class="agreementTxt" v-if="!agreement && !isNotice">請先閱讀注意事項</div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import CommonApiMixin from '@/mixins/commonApi';

export default {
  name: 'NoticeModal',

  mixins: [CommonApiMixin],

  props: {
    getUrl: {
      type: Object,
      default: () => {},
    },
    title: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      agreement: false,
    };
  },

  computed: {
    // 是否是注意事項
    isNotice() {
      return this.title !== '注意事項';
    },
  },

  methods: {
    QrgetData(data) {
      console.log('取data:', data);
      this.apiLoading = true;
      const url = '/GovEReceipt/FrontDeskService/QueryFNTSF';
      const method = 'post';
      this.axiosServiceSend(data, url, method, 'QrgetData');
    },
    // 使用共用API結果
    success(type, result) {
      console.log('result', result);
      switch (type) {
        case 'receiptQuerySelectBox': // 下拉選單
          // eslint-disable-next-line no-case-declarations
          const selectData = result.data.object;
          this.organList = selectData.organList;
          this.payItemList = selectData.payItemList;
          break;
        case 'QrgetData':
          console.log('QrgetData', result);
          this.$root.$emit('bv::hide::modal', 'modal-agreement');
          this.$emit('getDetailData', result.data.object[0]);
          this.apiLoading = false;
          break;
        default:
          break;
      }
      console.log('有資料');
    },
    fail(type, error) {
      switch (type) {
        case 'QrgetData':
          console.log(error);
          break;
        default:
          break;
      }
      console.log('沒資料');
      this.apiLoading = false;
    },
    goHome() {
      this.$router.push({
        name: 'home',
      });
    },
  },
};
</script>
